import { NumberFormater } from "../../Utils/helper";
import {
  GET_INPUT_DATA,
  CREATE_FOLDER,
  CREATED_FOLDER,
  GO_BACK,
  SCENARIAO_DATA_NEXT,
  SCENARIAO_BACK,
  UPLOAD_SCENARIO_DATA,
  UPLOAD_BASE_LINE_DATA,
  CLOSE_MODAL,
  BASE_LINE_UPLOADING_DONE,
  CLOSE_CREATED_FOLDER,
  CLOSE_SELECTED_FOLDER,
  UPLOAD_MASTER_FILE_ERROR,
  UPLOAD_MASTER_FILE_START,
  UPLOAD_MASTER_FILE_SUCCESS,
  INPUT_FOLDER_NAME,
  UPLOAD_BASE_LINE_START,
  UPLOAD_BASE_LINE_ERROR,
  UPLOAD_BASE_LINE_SUCCESS,
  BASE_LINE_UPLOADER,
  CLOSE_DONE_POPUP,
  CREATE_NEW_FOLDER_START,
  CREATE_NEW_FOLDER_SUCCESS,
  SELECTED_UPLOAD_FOLDER_ID,
  SELECTED_UPLOAD_SCENARIO_ID,
  CREATE_NEW_FOLDER_ERROR,
  CREATE_NEW_SCENARIO_ERROR,
  CREATE_NEW_SCENARIO_START,
  CREATE_NEW_SCENARIO_SUCCESS,
  UPLOAD_SCENARIO_LINE_START,
  UPLOAD_SCENARIO_LINE_ERROR,
  UPLOAD_SCENARIO_LINE_SUCCESS,
  OPEN_ERROR_POPUP,
  OPEN_ERROR_OR_WARNING_POPUP,
  CLOSE_ERROR_OR_WARNING_POPUP,
  CLOSE_ERROR_POPUP,
  VIEW_PRODUCT_TABLE,
  VIEW_PRODUCT_TABLE_SUCCESS,
  VIEW_PRODUCT_TABLE_ERROR,
  EDIT_PRODUCT_TABLE,
  EDIT_PRODUCT_TABLE_SUCCESS,
  EDIT_PRODUCT_TABLE_ERROR,
  API_USER_DATA,
  SELECTED_FOLDER_LIST,
  SELECTED_FOLDER_LIST_SUCCESS,
  SELECTED_UPLOAD_FOLDER_LIST_SUCCESS,
  SELECTED_FOLDER_LIST_ERROR,
  SELECTED_SCENARIO_LIST,
  SELECTED_SCENARIO_LIST_SUCCESS,
  SELECTED_SCENARIO_LIST_ERROR,
  DASHBOARD_SUMMARY_COST,
  DASHBOARD_SUMMARY_COST_SUCCESS,
  DASHBOARD_SUMMARY_COST_ERROR,
  SELECTED_CATEGORY_LIST,
  SELECTED_CATEGORY_LIST_SUCCESS,
  SELECTED_CATEGORY_LIST_ERROR,
  SELECTED_USECASE_LIST,
  SELECTED_USECASE_LIST_SUCCESS,
  SELECTED_USECASE_LIST_ERROR,
  GET_SCENARIO_NUMBER_ERROR,
  GET_SCENARIO_NUMBER_START,
  GET_SCENARIO_NUMBER_SUCCESS,
  IS_FOLDER_EXISTED,
  IS_SCENARIO_EXISTED,
  SELECTED_TIME_PERIOD_LIST,
  DISPLAY_FOLDER_LIST_SUCCESS,
  IS_DUPLICATE_SCENARIO_CREATED,
  ENABLE_EDIT,
  DISABLE_EDIT,
  FILE_UPLOAD_STATUS,
  CREATE_FOLDER_SCENARIO_ERROR,
  EDIT_SCENARIO_POPUP_FLAG,
  SET_PROCESSING_PACKAGING_PL,
  SET_SOURCE_BE_PART_OF_OPTIMIZATION,
  SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR,
  LOGIN_USER_DATA,
} from "./../Actions/ActionType";

const initialState = {
  isUsecaseSelected: false,
  isCategorySelected: false,
  isScenarioSelected: false,
  isTimePeriodSelected: false,
  isCreateFolder: false,
  isFolderCreated: false,
  isFolderExisted: false,
  isScenarioExisted: false,
  isFolderSelected: false,
  isTableloaded: false,
  isTableEdited: false,
  isScenarioaDataNext: false,
  isUploadScenario: false,
  isUploadBaseLineData: false,
  selectLineScenarioData: {},
  isBaseLineUploadingDone: false,
  dashboardSummaryCost: {
    baseLineCost: "0.00",
    bestScenarioCost: "0.00",
    scenarioCost: "0.00",
  },
  isLoading: false,
  uploadMasterFileMessage: "",
  uploadMasterFileError: "",
  inputFolderName: "",
  isDuplicateScenarioCreated: false,
  isLoadingBaseLine: false,
  isBaseLineUploader: false,
  isDone: false,
  folderCreationMessage: "",
  isScenarioCreated: false,
  scenarioCreationMessage: "",
  scenarioData: {},
  selectedFolderData: {},
  filteredFoldersList: [],
  selectedFolderId: 0,
  selectedUploadFolderId: 0,
  selectedUploadScenarioId: 0,
  selectedScenarioData: {},
  selectedTimePeriodData: [],
  selectedScenarioId: 0,
  selectedCategoryData: {},
  selectedCategoryId: 0,
  selectedUsecaseData: {},
  selectedUsecaseId: 0,
  scenarioNumber: 0,
  uploadScenarioMessage: "",
  isErrorDialog: false,
  errorMessage: "",
  editFilterEnable: false,
  fileUploadStatus: false,
  editPopupFlage: false,
  isProcessingPackagingPlantsDiff: true,
  isSourceBePartOfOptimization: true,
  isPackingPlantAddMinorIngredient: true,
  getLoginUserInfo: {},
};

const InputDataReducers = (state = initialState, action: any) => {
  // console.log('InputData Reducers action: ', action);
  switch (action.type) {
    case GET_INPUT_DATA:
      return {
        ...state,
      };

    case CREATE_FOLDER:
      return {
        ...state,
        isCreateFolder: true,
      };

    case CREATED_FOLDER:
      return {
        ...state,
        isFolderCreated: true,
      };

    case GO_BACK:
      return {
        ...state,
        isCreateFolder: false,
      };

    case SCENARIAO_DATA_NEXT:
      return {
        ...state,
        isScenarioaDataNext: true,
      };

    case SCENARIAO_BACK:
      return {
        ...state,
        isScenarioaDataNext: false,
      };

    case UPLOAD_SCENARIO_DATA:
      return {
        ...state,
        isUploadScenario: true,
        scenarioData: action.data,
      };

    case UPLOAD_BASE_LINE_DATA:
      return {
        ...state,
        isUploadBaseLineData: true,
      };

    case BASE_LINE_UPLOADING_DONE:
      return {
        ...state,
        isBaseLineUploadingDone: true,
      };
    case CLOSE_CREATED_FOLDER:
      return {
        ...state,
        isFolderCreated: false,
      };
    case CLOSE_SELECTED_FOLDER:
      return {
        ...state,
        isFolderSelected: false,
      };
    case INPUT_FOLDER_NAME:
      return {
        ...state,
        inputFolderName: action.data,
      };
    case IS_DUPLICATE_SCENARIO_CREATED:
      return {
        ...state,
        isDuplicateScenarioCreated: action.data,
      };

    case IS_FOLDER_EXISTED:
      return {
        ...state,
        isFolderExisted: action.data,
      };

    case IS_SCENARIO_EXISTED:
      return {
        ...state,
        isScenarioExisted: action.data,
      };
    case CREATE_FOLDER_SCENARIO_ERROR:
      return {
        ...state,
        createrFolderOrScenarioError: action.data,
      };
    // Display Dashboard Summary Cost
    case DASHBOARD_SUMMARY_COST:
      return {
        ...state,
        dashboardSummaryCost: {
          baseLineCost: "0.00",
          bestScenarioCost: "0.00",
          scenarioCost: "0.00",
        },
      };
    case DASHBOARD_SUMMARY_COST_SUCCESS:
      return {
        ...state,
        dashboardSummaryCost: {
          baseLineCost: NumberFormater(action?.data?.baseLineCost),
          bestScenarioCost: NumberFormater(action?.data?.bestScenarioCost),
          scenarioCost: NumberFormater(action?.data?.scenarioCost),
        },
      };
    case DASHBOARD_SUMMARY_COST_ERROR:
      return {
        ...state,
        dashboardSummaryCost: {
          baseLineCost: "0.00",
          bestScenarioCost: "0.00",
          scenarioCost: "0.00",
        },
      };

    case CLOSE_MODAL:
      return {
        ...state,
        isCreateFolder: false,
        isFolderCreated: false,
        isScenarioaDataNext: false,
        isUploadScenario: false,
        isUploadBaseLineData: false,
      };

    //open close error dialog

    case OPEN_ERROR_OR_WARNING_POPUP:
      return {
        ...state,
        isErrorOrWarningDialog: true,
        errorOrWarningMessage: action?.error,
      };
    case CLOSE_ERROR_OR_WARNING_POPUP:
      return {
        ...state,
        isErrorOrWarningDialog: false,
        errorOrWarningMessage: "",
      };

    case OPEN_ERROR_POPUP:
      const errorPayload = action?.error;
      const errorMsg =
        typeof errorPayload === "string"
          ? errorPayload
          : errorPayload?.message ||
            errorPayload?.response?.data?.detail ||
            errorPayload?.response?.data?.message ||
            errorPayload?.response?.data?.title ||
            errorPayload?.response?.data ||
            errorPayload?.message ||
            "An unexpected error occurred";

      return {
        ...state,
        isErrorDialog: true,
        errorMessage: errorMsg,
      };
    case "OPEN_DONE_POPUP":
      return {
        ...state,
        isDone: true,
        uploadMasterFileMessage: action?.data || state.uploadMasterFileMessage,
      };
    case CLOSE_ERROR_POPUP:
      return {
        ...state,
        isErrorDialog: false,
        errorMessage: "",
      };
    case UPLOAD_MASTER_FILE_START:
      return {
        ...state,
        isLoading: true,
      };
    case UPLOAD_MASTER_FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDone: true,
        uploadMasterFileMessage:
          (action?.data && (action.data.message || action.data)) || "",
      };
    case UPLOAD_MASTER_FILE_ERROR:
      return {
        ...state,
        isLoading: false,
        isDone: false,
        uploadMasterFileError: action.error,
      };
    //Input Folder Name
    // case INPUT_FOLDER_NAME:
    //   return {
    //     ...state,
    //     inputFolderName: action.data,
    //   };

    //Upload base file
    case UPLOAD_BASE_LINE_START:
      return {
        ...state,
        isLoadingBaseLine: true,
      };
    case UPLOAD_BASE_LINE_SUCCESS:
      return {
        ...state,
        isLoadingBaseLine: false,
        uploadMasterFileMessage: action?.data?.message,
        isBaseLineUploader: false,
        isDone: true,
      };
    case UPLOAD_BASE_LINE_ERROR:
      return {
        ...state,
        isLoadingBaseLine: false,
        isBaseLineUploader: false,
        uploadMasterFileError: action.error,
      };
    case BASE_LINE_UPLOADER:
      return {
        ...state,
        isBaseLineUploader: true,
      };
    case CLOSE_DONE_POPUP:
      return {
        ...state,
        isDone: false,
        uploadMasterFileMessage: "",
      };

    //Create new folder
    case CREATE_NEW_FOLDER_START:
      return {
        ...state,
        isFolderCreated: false,
      };
    case CREATE_NEW_FOLDER_SUCCESS:
      return {
        ...state,
        folderCreationMessage: action.data?.message,
        selectedFolderId: action.data,
        selectedUploadFolderId: action.data,
        isFolderCreated: true,
      };
    case SELECTED_UPLOAD_FOLDER_ID:
      return {
        ...state,
        selectedUploadFolderId: action.data,
      };
    case SELECTED_UPLOAD_SCENARIO_ID:
      return {
        ...state,
        selectedUploadScenarioId: action.data,
      };
    case CREATE_NEW_FOLDER_ERROR:
      return {
        ...state,
        isFolderCreated: false,
      };

    // Get Scenario Number
    case GET_SCENARIO_NUMBER_START:
      return {
        ...state,
      };
    case GET_SCENARIO_NUMBER_SUCCESS:
      return {
        ...state,
        scenarioNumber: action.data,
      };
    case GET_SCENARIO_NUMBER_ERROR:
      return {
        // ...state,
      };

    // Selected Usecase list
    case SELECTED_USECASE_LIST:
      return {
        ...state,
        isUsecaseSelected: false,
        selectedUsecaseId: 0,
      };
    case SELECTED_USECASE_LIST_SUCCESS:
      return {
        ...state,
        isUsecaseSelected: true,
        selectedUsecaseData: action.data,
        selectedUsecaseId: action.data?.id || action.data,
      };
    case SELECTED_USECASE_LIST_ERROR:
      return {
        // ...state,
        isUsecaseSelected: false,
      };

    // Selected Category list
    case SELECTED_CATEGORY_LIST:
      return {
        ...state,
        isCategorySelected: false,
        selectedCategoryId: 0,
      };
    case SELECTED_CATEGORY_LIST_SUCCESS:
      return {
        ...state,
        isCategorySelected: true,
        selectedCategoryData: action.data,
        selectedCategoryId: action.data?.id || action.data,
      };
    case SELECTED_CATEGORY_LIST_ERROR:
      return {
        // ...state,
        isCategorySelected: false,
      };

    // Selected Scenario list
    case SELECTED_SCENARIO_LIST:
      return {
        ...state,
        isScenarioSelected: false,
        selectedScenarioId: 0,
      };
    case SELECTED_SCENARIO_LIST_SUCCESS:
      return {
        ...state,
        isScenarioSelected: true,
        selectedScenarioData: action.data,
        selectedScenarioId: action.data?.scenario_id || action.data,
      };
    case SELECTED_TIME_PERIOD_LIST:
      return {
        ...state,
        isTimePeriodSelected: true,
        selectedTimePeriodData: action.data,
      };
    case SELECTED_SCENARIO_LIST_ERROR:
      return {
        // ...state,
        isScenarioSelected: false,
      };

    case API_USER_DATA:
      return {
        ...state,
        apiUserData: action.data,
      };
    // Selected folder list
    case SELECTED_FOLDER_LIST:
      return {
        ...state,
        isFolderSelected: false,
        selectedFolderId: 0,
      };
    case SELECTED_FOLDER_LIST_SUCCESS:
      return {
        ...state,
        //isFolderSelected: true,
        selectedFolderData: action.data,
        selectedFolderId: action.data?.id || action.data,
        //selectedUploadFolderId: action.data?.id
      };

    case DISPLAY_FOLDER_LIST_SUCCESS:
      return {
        ...state,
        //isFolderSelected: true,
        filteredFoldersList: action.data,
        //selectedFolderId: action.data?.id,
        //selectedUploadFolderId: action.data?.id
      };

    case SELECTED_UPLOAD_FOLDER_LIST_SUCCESS:
      return {
        ...state,
        isFolderSelected: true,
        selectedFolderData: action.data,
        selectedUploadFolderId: action.data?.id,
      };
    case SELECTED_FOLDER_LIST_ERROR:
      return {
        // ...state,
        isFolderSelected: false,
      };

    //Create new Scenario
    case CREATE_NEW_SCENARIO_START:
      return {
        ...state,
        isScenarioCreated: false,
      };
    case CREATE_NEW_SCENARIO_SUCCESS:
      return {
        ...state,
        scenarioCreationMessage: action.data?.message,
        selectedUploadScenarioId: action.data,
        isScenarioCreated: true,
      };
    case CREATE_NEW_SCENARIO_ERROR:
      return {
        ...state,
        isScenarioCreated: false,
      };

    //Upload scenario data
    case UPLOAD_SCENARIO_LINE_START:
      return {
        ...state,
        isUploadScenario: false,
      };
    case UPLOAD_SCENARIO_LINE_SUCCESS:
      return {
        ...state,
        uploadScenarioMessage: action.data?.message,
        isUploadScenario: true,
        isDone: true,
      };
    case UPLOAD_SCENARIO_LINE_ERROR:
      return {
        ...state,
        isUploadScenario: false,
      };

    // Display Product Table Data
    case VIEW_PRODUCT_TABLE:
      return {
        ...state,
        isTableloaded: false,
      };
    case VIEW_PRODUCT_TABLE_SUCCESS:
      return {
        ...state,
        isTableloaded: true,
      };
    case VIEW_PRODUCT_TABLE_ERROR:
      return {
        ...state,
        isTableloaded: false,
      };

    // Edit Product Table Data
    case EDIT_PRODUCT_TABLE:
      return {
        ...state,
        isTableEdited: false,
      };
    case EDIT_PRODUCT_TABLE_SUCCESS:
      return {
        ...state,
        isTableEdited: true,
      };
    case EDIT_PRODUCT_TABLE_ERROR:
      return {
        ...state,
        isTableEdited: false,
      };
    case ENABLE_EDIT:
      return {
        ...state,
        editFilterEnable: true,
      };
    case DISABLE_EDIT:
      return {
        ...state,
        editFilterEnable: false,
      };

    case FILE_UPLOAD_STATUS:
      return {
        ...state,
        fileUploadStatus: true,
      };

    case EDIT_SCENARIO_POPUP_FLAG:
      return {
        ...state,
        editPopupFlage: action.data,
      };
    case SET_PROCESSING_PACKAGING_PL:
      return {
        ...state,
        isProcessingPackagingPlantsDiff: action.data,
      };

    case SET_SOURCE_BE_PART_OF_OPTIMIZATION:
      return {
        ...state,
        isSourceBePartOfOptimization: action.data,
      };

    case SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR:
      return {
        ...state,
        isPackingPlantAddMinorIngredient: action.data,
      };

    case LOGIN_USER_DATA:
      return {
        ...state,
        getLoginUserInfo: action.data,
      };

    default:
      return {
        ...state,
      };
  }
};

export default InputDataReducers;
